import { render } from "./ChinaBanner.vue?vue&type=template&id=c4594dd4&scoped=true"
import script from "./ChinaBanner.vue?vue&type=script&lang=js"
export * from "./ChinaBanner.vue?vue&type=script&lang=js"

import "./ChinaBanner.vue?vue&type=style&index=0&id=c4594dd4&scoped=true&lang=css"
import "./ChinaBanner.vue?vue&type=style&index=1&id=c4594dd4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4594dd4"]])

export default __exports__